//export const API_URL = "https://localhost:44385";
//export const API_URL = "https://devapi.medsolutions.plus";
//export const API_URL = "https://dasiapi.azurewebsites.net"; //DEV
//export const API_URL = "https://dasialiveapi.azurewebsites.net";  //LIVE
//export const API_URL = "https://api.dasiaoptics.com";  //LIVE 
export const API_URL = "https://pgapi.dasiaoptics.com"; //LIVE  //postgres
//export const API_URL = "https://pgdevapi.dasiaoptics.com"; //DEV  //postgres